import { Col, Row, Typography } from "antd";
import Container from "components/Common/Container";
import { Analytics } from "utils/Analytics/AnalyticsHelper";

const { Title, Text, Paragraph } = Typography;

const ContactUS: React.FC = () => (
  <Container type="fluid" className="about-contact">
    <Container>
      <Title level={3} className="about-contact-title">
        Let&apos;s connect!
      </Title>
      <Row gutter={{ xs: 0, md: 30 }} align="middle" justify="center">
        <Col xs={22} md={12}>
          <Paragraph className="contact-card">
            <Paragraph>
              <Paragraph className="cc-title">Reach out</Paragraph>
              <Paragraph className="cc-content">
                {/* <a href="tel:+917878541186">
                  <Text className="number">
                    <b>+91</b>7878541186
                  </Text>
                </a> */}
                <Paragraph style={{ marginTop: 10 }}>
                  <a
                    href="mailto:support@topmate.io"
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => Analytics.track("Support Initiated")}
                  >
                    support@topmate.io
                  </a>
                </Paragraph>
              </Paragraph>
            </Paragraph>
          </Paragraph>
        </Col>
        <Col xs={22} md={12}>
          <Paragraph className="contact-card">
            <Paragraph>
              <Paragraph className="cc-title">Address</Paragraph>
              <Paragraph className="cc-content">
                Topmate.io, 548 Market St PMB 30073, San Francisco, California
                94104-5401 US
              </Paragraph>
            </Paragraph>
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </Container>
);

export default ContactUS;
